import { CfarOfferType } from "redmond";
import type {
  CfarRateQuote,
  CfarRateQuoteSuccess,
} from "@b2bportal/lodging-api";

export type HtsCfarRateQuoteSuccess = CfarRateQuoteSuccess & {
  offerType: { CfarOfferType: CfarOfferType.Hts };
};
export function isHtsCfarOffer(
  cfarQuote: CfarRateQuote | undefined
): cfarQuote is HtsCfarRateQuoteSuccess {
  return (
    cfarQuote?.CfarRateQuote === "Success" &&
    cfarQuote.offerType.CfarOfferType === CfarOfferType.Hts
  );
}
